import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-section-title",
    templateUrl: "./section-title.component.html",
    styleUrls: ["./section-title.component.scss"],
})
export class SectionTitleComponent {}
